import { useAuth0 } from "@auth0/auth0-react";
import { FC, ReactNode, useEffect } from "react";
import {
  LOGOUT_CHANNEL,
  LOGOUT_MESSAGE,
  POST_LOGOUT_KEY,
} from "../hooks/useLogout";

interface PostLogoutHandlerProps {
  children: ReactNode;
  loadingPage: ReactNode;
}

export const PostLogoutHandler: FC<PostLogoutHandlerProps> = ({
  children,
  loadingPage,
}) => {
  const { loginWithRedirect, logout } = useAuth0();
  const isPostLogout = localStorage.getItem(POST_LOGOUT_KEY) === "1";

  useEffect(() => {
    if (isPostLogout) {
      localStorage.removeItem(POST_LOGOUT_KEY);
      void loginWithRedirect({ authorizationParams: { prompt: "login" } });
    }
  }, [isPostLogout, loginWithRedirect]);

  useEffect(() => {
    const channel = new BroadcastChannel(LOGOUT_CHANNEL);
    channel.onmessage = (event: MessageEvent) => {
      if (event.data !== LOGOUT_MESSAGE) return;
      sessionStorage.clear();
      void logout({ openUrl: false }).then(() =>
        loginWithRedirect({ authorizationParams: { prompt: "login" } }),
      );
    };

    return () => channel.close();
  }, [logout, loginWithRedirect]);

  if (isPostLogout) {
    return loadingPage;
  }

  return children;
};
